<template>
    <div class="task-container">
        <div class="top-title">
            <div class="left-tit">做任务领活力值</div>
            <div class="right-tit">
                <div class="right-desc" @click="onMoreClick">更多任务</div>
                <div class="right-arrow"></div>
            </div>
        </div>
        <div class="crad-area">
            <div
                class="card-item"
                :class="{ 'item-bg-orange': ['marketing', 'signIn'].includes(item.taskType) }"
                v-for="(item, index) in computedTaskList"
                :key="index"
                @click="onItemClick(item)"
            >
                <div class="card-tit">
                    <div class="tit-text">{{ item.title }}</div>
                    <div class="tit-desc" v-if="item.taskType === 'marketing'">
                        <span class="desc-prefix">限时</span>
                        <span>+{{ item.afterRewardScore }}</span>
                        <span class="desc-suffix">+{{ item.score }}</span>
                    </div>
                    <div class="tit-desc" v-if="item.taskType === 'normal'">
                        <span>+{{ item.afterRewardScore }}</span>
                    </div>
                </div>
                <div class="card-desc">
                    <div class="desc-text">{{ item.desc }}</div>
                    <div
                        class="right-arrow"
                        v-if="['marketing', 'normal', 'allmore'].includes(item.taskType)"
                    ></div>
                </div>
                <div
                    class="card-btn"
                    :class="{ disabled: item.status === 3 }"
                    v-if="item.taskType === 'signIn'"
                >
                    {{ item.status === 3 ? '已签到' : '签到' }}
                </div>
                <div class="extra-desc flex-box" v-if="item.taskType === 'marketing'">
                    <span>限时悬赏</span>
                    <CountDown
                        class="count-down-timer"
                        id="yx-countdownValue"
                        format="HH:mm:ss"
                        :time="item.countDown"
                    />
                </div>
                <div class="extra-desc" v-if="item.taskType === 'signIn'">
                    剩余{{ item.countDown }}天
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CountDown } from 'vant';
export default {
    components: { CountDown },
    props: ['taskList'],
    computed: {
        computedTaskList() {
            let list = this.taskList;
            list.push({
                title: '查看全部任务',
                desc: '获取更多活力值',
                taskType: 'allmore'
            });
            return list;
        }
    },
    methods: {
        onMoreClick() {
            this.$emit('OnTaskMoreClick');
        },
        onItemClick(item) {
            if (item.taskType === 'signIn' && item.status === 3) return;
            if (item.taskId) {
                let time = Date.now();
                let param = {
                    receiveTime: time,
                    taskId: item.taskId
                };
                let listArr = JSON.parse(localStorage.getItem('KTaskIDListStr'));
                if (listArr && listArr.length > 0) {
                    let tepArr = [];
                    listArr.forEach(element => {
                        tepArr.push(element.taskId);
                    });
                    if (tepArr.indexOf(item.taskId) === -1) {
                        listArr.push(param);
                        localStorage.setItem('KTaskIDListStr', JSON.stringify(listArr));
                    }
                } else {
                    localStorage.setItem('KTaskIDListStr', JSON.stringify([param]));
                }
            }
            this.$emit('OnTaskItemClick', item);
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@asserts_4_0: '../../../../assets/iconV4.0/';
.task-container {
    margin-bottom: 20px;
    z-index: 100;
    width: 375px;
    .top-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 4px 18px 0;
        line-height: 18px;
        .left-tit {
            color: #002a3c;
            font-size: 18px;
            font-weight: bold;
        }
        .right-tit {
            display: flex;
            flex-direction: row;
            align-items: center;
            .right-desc {
                color: #254d5e;
                font-size: 13px;
            }
            .right-arrow {
                margin-left: 4px;
                width: 6px;
                height: 10px;
                background-size: 100% 100%;
                background-image: url('@{asserts}/mygrade-arrow@2x.png');
            }
        }
    }
    .crad-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        padding: 20px 18px 10px;
        overflow-x: auto;
        overflow-y: hidden;
        .card-item {
            width: 225px;
            min-width: 225px;
            height: 70px;
            border-radius: 5px;
            border: 1px solid #ffffff;
            background: #ffffff;
            padding: 16px 0px 16px 12px;
            margin-right: 8px;
            position: relative;
            &.item-bg-orange {
                background: linear-gradient(180deg, #fef7ec 0%, #ffe0c7 100%);
            }
            .card-tit {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: nowrap;
                .tit-text {
                    font-size: 14px;
                    font-weight: 600;
                    color: #863e1e;
                    line-height: 20px;
                }
                .tit-desc {
                    margin-left: 4px;
                    font-size: 12px;
                    font-weight: bold;
                    color: #f6652f;
                    line-height: 17px;
                    border-radius: 8px 3px 3px 8px;
                    padding: 0px 5px 0px 21px;
                    background-color: #ffdaa4;
                    background-image: url('@{asserts_4_0}/VIP-icon@2x.png');
                    background-position: left center;
                    background-size: 17px 17px;
                    background-repeat: no-repeat;
                    .desc-prefix {
                        font-size: 11px;
                        font-weight: normal;
                    }
                    .desc-suffix {
                        font-size: 11px;
                        font-weight: normal;
                        color: #f6a986;
                        text-decoration: line-through;
                        margin-left: 3px;
                    }
                }
            }
            .card-desc {
                margin-top: 4px;
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: nowrap;
                max-width: 363px;
                overflow: hidden;
                .desc-text {
                    font-size: 11px;
                    font-weight: 400;
                    color: #863e1e;
                    opacity: 0.65;
                    line-height: 16px;
                    white-space: nowrap;
                }
                .right-arrow {
                    margin-left: 4px;
                    width: 6px;
                    height: 6px;
                    background-size: 100% 100%;
                    background-image: url('@{asserts}/arrow-right@2x.png');
                }
            }
            .card-btn {
                position: absolute;
                top: 22px;
                right: 9px;
                width: 56px;
                height: 24px;
                background: #ffffff;
                box-shadow: 0px 2px 7px 0px rgba(255, 176, 113, 0.5);
                border-radius: 12px;
                font-size: 12px;
                font-weight: 600;
                color: #ff6a00;
                text-align: center;
                line-height: 24px;
                &.disabled {
                    color: #ffc297;
                }
            }
            .extra-desc {
                position: absolute;
                top: 0;
                transform: translateY(-50%);
                right: -1px;
                padding: 3px 9px;
                height: 20px;
                background: linear-gradient(90deg, #ff8300 0%, #ffb974 100%);
                box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
                border-radius: 10px 10px 0px 10px;
                font-size: 10px;
                font-weight: 600;
                color: #ffffff;
                text-align: center;
                line-height: 14px;
                &.flex-box {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                }
                .count-down-timer {
                    font-size: 10px;
                    font-weight: 600;
                    color: #ffffff;
                    text-align: center;
                    line-height: 14px;
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>